import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSystemLogoMark = (props) => /* @__PURE__ */ _jsxs("svg", {
	id: "Layer_1",
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 345.6 156",
	...props,
	children: [/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("style", { children: "\n      .st0 {\n        fill: #ffbf02;\n      }\n    " }) }), /* @__PURE__ */ _jsxs("g", { children: [
		/* @__PURE__ */ _jsx("path", {
			className: "st0",
			d: "M190.1.7H12.8C5.7.7,0,6.5,0,13.5s5.7,12.8,12.8,12.8h177.3c7,0,12.8-5.7,12.8-12.8s-5.7-12.8-12.8-12.8Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "st0",
			d: "M115.6,128.8H12.8c-7,0-12.8,5.7-12.8,12.8s5.7,12.8,12.8,12.8h102.8c7,0,12.8-5.7,12.8-12.8s-5.7-12.8-12.8-12.8Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "st0",
			d: "M270.1,148.1l75.5-127.8c3.6-6.1,1.6-13.9-4.5-17.5-2-1.2-4.2-1.8-6.5-1.8-4.5,0-8.7,2.4-11,6.3l-59.3,100.4-5.2,8.8-5.2-8.8-15-25.4-1.8-3.1,1.8-3.1,33-55.9c3.6-6.1,1.6-13.9-4.5-17.5-2-1.2-4.2-1.8-6.5-1.8-4.5,0-8.7,2.4-11,6.3l-38.6,65.3h0s0,0,0,0h0c0,0-20.7,35.1-20.7,35.1l-5.2,8.8-5.2-8.8-21.6-36.6c0-.1-.2-.3-.2-.4-.1-.2-.3-.4-.4-.6-.1-.2-.2-.3-.4-.5-.1-.2-.2-.3-.4-.5-.2-.2-.3-.4-.5-.5-.1-.1-.2-.2-.4-.4-.2-.2-.4-.3-.5-.5-.1-.1-.3-.2-.4-.3-.2-.1-.4-.3-.6-.4-.2-.1-.3-.2-.5-.3-.2-.1-.4-.2-.6-.3-.2-.1-.4-.2-.6-.3-.2,0-.3-.2-.5-.2-.2,0-.4-.2-.6-.3-.2,0-.3-.1-.5-.2-.2,0-.4-.1-.7-.2-.2,0-.4,0-.5-.1-.2,0-.4,0-.7-.1-.2,0-.4,0-.6,0-.2,0-.4,0-.6,0-.3,0-.5,0-.8,0-.1,0-.3,0-.4,0H12.8c-7,0-12.8,5.7-12.8,12.8s5.7,12.8,12.8,12.8h127.6l1.7,2.9,32.4,54.8c2.3,3.9,6.5,6.3,11,6.3s8.7-2.4,11-6.3l20.6-35,5.2-8.8,5.2,8.8,20.6,35c2.3,3.9,6.5,6.3,11,6.3s8.7-2.4,11-6.3Z"
		})
	] })]
});
export default SvgSystemLogoMark;
